import { useEffect, useRef } from 'react';
import type { Avatar, Facing } from '@sokdaq/protocol';
import { drawAvatar } from '../office/draw-avatar.js';

/**
 * 아바타 미리보기.
 *
 * 오피스 뷰와 같은 그리기 함수를 쓴다. 미리보기를 따로 그리면 둘이
 * 어긋나서, 고를 때 본 모습과 맵에 서 있는 모습이 달라진다.
 */
export function AvatarPreview({
  avatar,
  facing = 'down',
  scale = 2,
}: {
  avatar: Avatar;
  facing?: Facing;
  scale?: number;
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  // 화면 크기(CSS 픽셀)와 실제 버퍼 크기를 분리한다. 픽셀 아트라
  // 브라우저 보간에 맡기면 뭉개진다 — 배율을 컨텍스트에 직접 준다.
  const width = 24;
  const height = 34;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas === null) return;

    const ctx = canvas.getContext('2d');
    if (ctx === null) return;

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.imageSmoothingEnabled = false;
    ctx.scale(scale, scale);

    // 발밑 기준 좌표라 아래쪽에 세운다. walkPhase는 0 — 서 있는 자세.
    drawAvatar(ctx, width / 2, height - 1, avatar, facing, 0);
  }, [avatar, facing, scale]);

  return (
    <canvas
      ref={canvasRef}
      width={width * scale}
      height={height * scale}
      style={{ width: width * scale, height: height * scale, imageRendering: 'pixelated' }}
      aria-label="아바타 미리보기"
    />
  );
}
